import React, { useState, useEffect, useCallback } from 'react';
import Select from 'react-select';
import './WorldClock.css';

function WorldClock() {
  const [city, setCity] = useState('Europe/London');
  const [time, setTime] = useState('');
  const [hour, setHour] = useState(null);
  const [cityInput, setCityInput] = useState({ label: 'Europe/London', value: 'Europe/London' });
  const [groupedOptions, setGroupedOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const getGreeting = () => {
    if (hour >= 5 && hour < 12) return 'Good Morning! ☀️';
    if (hour >= 12 && hour < 17) return 'Good Afternoon! ☕';
    if (hour >= 17 && hour < 21) return 'Good Evening! 🌇';
    return 'Good Night! 🌙';
  };

  const greeting = hour !== null ? getGreeting() : '';

  const groupTimezones = (timezones) => {
    const favorites = ['Asia/Karachi', 'Europe/London', 'America/New_York', 'Asia/Tokyo'];
    const favOptions = [];
    const groups = {};

    timezones.forEach((tz) => {
      const [continent] = tz.split('/');
      const option = { label: tz, value: tz };
      if (favorites.includes(tz)) favOptions.push(option);
      if (!groups[continent]) groups[continent] = [];
      groups[continent].push(option);
    });

    const grouped = Object.entries(groups).map(([label, options]) => ({
      label,
      options: options.sort((a, b) => a.label.localeCompare(b.label)),
    }));

    if (favOptions.length > 0) {
      grouped.unshift({ label: '⭐ Favorites', options: favOptions });
    }

    return grouped;
  };

  const fetchTimezones = useCallback(async () => {
    try {
      const res = await fetch('http://localhost:5000/api/timezones');
      const data = await res.json();
      const grouped = groupTimezones(data);
      setGroupedOptions(grouped);
    } catch (err) {
      console.error('Failed to load timezones:', err);
    }
  }, []);

  const fetchTime = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const response = await fetch(`http://localhost:5000/api/time/${city}`);
      const data = await response.json();
      const dt = data.dateTime || data.datetime;
      if (dt) {
        const localDate = new Date(dt);
        setTime(localDate.toLocaleString());
        setHour(localDate.getHours());
      } else if (data.error) {
        setError('Invalid timezone');
        setTime('');
      } else {
        setError('Unexpected API response');
        setTime('');
      }
    } catch (err) {
      console.error('Error fetching time:', err);
      setError('Failed to fetch time');
      setTime('');
    }
    setLoading(false);
  }, [city]);

  useEffect(() => {
    fetchTimezones();
    fetchTime();
    const intervalId = setInterval(fetchTime, 60000);
    return () => clearInterval(intervalId);
  }, [fetchTime, fetchTimezones]);

  const handleChange = (selectedOption) => {
    setCityInput(selectedOption);
    setCity(selectedOption.value);
  };

  return (
    <div className="world-clock-container">
      <div className="clock-content">
        <h4 className="text-center text-golden">🌍 World Clock</h4>

        <div className="mb-3">
          <Select
            className="react-select-container"
            classNamePrefix="react-select"
            options={groupedOptions}
            value={cityInput}
            onChange={handleChange}
            placeholder="🌐 Select Region / City"
            isSearchable
          />
        </div>

        <div className="text-center">
          <h5 className="text-golden">Current Time in {city}:</h5>
          {loading && <p>Loading...</p>}
          {error && <p className="text-danger">{error}</p>}
          {!loading && !error && time && (
            <>
              <p className="time-display">{time}</p>
              <h6 className="mt-3">{greeting}</h6>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default WorldClock;
